// Site URL for SEO (canonical, Open Graph, sitemap parity).
// Production canonical domain — non-www. REACT_APP_SITE_URL overrides per env.
export const SITE_URL = (
  process.env.REACT_APP_SITE_URL || "https://crownedcanvascreations.com"
).replace(/\/$/, "");

export const DEFAULT_OG_IMAGE = "/og-image.jpg";
export const LOGO_PATH = "/crowned-logo.png";

export const ORGANIZATION_JSONLD = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Crowned Canvas Creations LLC",
  url: SITE_URL,
  logo: `${SITE_URL}${LOGO_PATH}`,
  description:
    "Crowned Canvas Creations transforms meaningful photographs, milestones and personal stories into custom artwork. Based in Madison, Wisconsin.",
  address: {
    "@type": "PostalAddress",
    addressLocality: "Madison",
    addressRegion: "WI",
    addressCountry: "US",
  },
};

export const WEBSITE_JSONLD = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "Crowned Canvas Creations",
  url: SITE_URL,
};
